export const equipmentSortStackColumn = [
    'equipmentId',
    'equipmentTag',
    'techIdentificationNumber',
    'functionalLocation'
]
